import dynamic from 'next/dynamic';

import { useParentProject } from '@/hooks/queries/useParentProject';

const ParentExposeLink = dynamic(() => import('./ParentExposeLink').then((mod) => mod.ParentExposeLink));

export const DynamicParentExposeLink = () => {
  const { data: parentProject } = useParentProject();
  if (!parentProject) return null;

  return <ParentExposeLink parentProject={parentProject} />;
};
